import { useEffect, useState } from "react";
import { ActionIcon, Transition } from "@mantine/core";

import { useMediaQuery } from "@mantine/hooks";
import { ArrowUpIcon } from "../../../shared/svg/ArrowUpIcon";
import { scrollToTop } from "../../../utils/helpers";

export const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);

  const handleScroll = () => {
    setVisible(window.scrollY > 300); // показувати кнопку після 300px
  };

  const isWide = useMediaQuery("(min-width: 1100px)");
  const isMedium = useMediaQuery("(min-width: 670px)");
  const isMobile = useMediaQuery("(max-width: 650px)");

  const buttonSize = isWide ? 64 : isMedium ? 48 : 36;

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <Transition
      mounted={visible}
      transition="fade"
      duration={200}
      timingFunction="ease"
    >
      {(styles) => (
        <ActionIcon
          variant="filled"
          color="rgba(190, 75, 219, 0.7) "
          radius="xl"
          style={{
            ...styles,
            position: "fixed",
            bottom: isMobile ? 66 : 32,
            right: isMobile ? 24 : 32,
            zIndex: 1,
            width: buttonSize,
            height: buttonSize,
          }}
          onClick={scrollToTop}
        >
          <ArrowUpIcon />
        </ActionIcon>
      )}
    </Transition>
  );
};
